var Menu = require("./module/menu")
module.exports = Menu.default;
